import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router";

import MappingError from "@/components/membership/Template/MappingError";
import TemplateFallback from "@/components/membership/Template/TemplateFallback";

export default function TemplateErrorsModal({ isOpen, onClose, errors }) {
  const errorCount = errors?.errors?.length || 0;
  const navigate = useNavigate();

  const handleSelectDifferentFile = () => {
    navigate("/membership/update-data/select-file");
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <ErrorBoundary FallbackComponent={TemplateFallback}>
          <DialogTitle sx={{ backgroundColor: "#ff00007a" }}>
            Template Mapping Errors
          </DialogTitle>
          <DialogContent sx={{ paddingTop: "12px !important" }}>
            <DialogContentText>
              <Box>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "500",
                      marginBottom: "5px",
                      color: "red",
                    }}
                  >
                    Make sure you have chosen the correct data file
                  </Typography>
                  -or-
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "500",
                      marginBottom: "5px",
                      color: "red",
                    }}
                  >
                    Re-map these fields to an available column or <i>None</i>
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    margin: "15px 0 15px 0",
                    fontSize: ".9rem",
                  }}
                >
                  <Chip
                    label={errorCount}
                    size="small"
                    sx={{
                      backgroundColor: "red",
                      color: "white",
                      fontWeight: "bold",
                      marginRight: "5px",
                    }}
                  ></Chip>
                  columns mapped in this template are missing from your selected
                  data file.
                </Typography>
              </Box>
              <Box>
                {errors?.errors?.map((error, index) => {
                  return <MappingError key={index} problem={error} />;
                })}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="siteBlue" onClick={handleSelectDifferentFile}>
              Select a different file
            </Button>
            <Button className="siteBlue" onClick={onClose}>
              Re-map current fields
            </Button>
          </DialogActions>
        </ErrorBoundary>
      </Dialog>
    </>
  );
}
